/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersMessage } from '../message/message';
export var EmbersFeedback = function EmbersFeedback(_ref) {
  var _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? [] : _ref$messages,
    fullScreen = _ref.fullScreen;
  var renderContent = function renderContent() {
    var isMixed = messages.length > 1;
    return messages.map(function (v, i) {
      return /*#__PURE__*/React.createElement(EmbersMessage, {
        style: {
          marginBottom: i < messages.length - 1 ? 16 : 0
        },
        key: i,
        type: v.type
        // multiple message will not have a title
        ,
        isHeader: isMixed ? false : true,
        size: isMixed ? 'medium' : 'large',
        align: !!v.description || isMixed || fullScreen ? 'left' : 'center',
        extraText: v.description,
        extraTextComponentType: v.descriptonComponentType
      }, v.message);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderContent());
};